import classNames from "classnames";
import { format } from "date-fns";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { Api } from "../../../services/api";
import { formatCurrency } from "../../../utils/formatCurrency";

export const HistoricoPropostaDialog = ({ proposta_id, close }) => {
  const [historicoPropostaData, setHistoricoPropostaData] = useState()
  const [reload] = useState()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const consultaPropostaHistorico = async () => {
      setLoading(true)
      try {
        const { data } = await Api.get(`/propostas/historico/${proposta_id}`)
        setHistoricoPropostaData(data)
      } catch (error) {
        console.log(error.response)
      } finally {
        setLoading(false)
      }
    }
    consultaPropostaHistorico()
  }, [reload])

  return (
    <Dialog
      visible
      header={`Histórico da proposta`}
      pt={{
        root: 'max-w-screen lg:max-h-[90vh]',
        headerTitle: 'font-bold text-xl w-full text-center',
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full max-h-[80vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow": state.maximized
          })
        }),
      }}
      onHide={() => close()}
    //footer={footer}
    >
      <div className="grid justify-center w-full">
        <div className="w-full mt-4">
          <DataTable
            value={historicoPropostaData}
            header=""
            loading={loading}
            emptyMessage="Vazio"
          >
            <Column field="pnht_proposta_descricao" header="Justificativa" />
            <Column field="pnht_valor_proposta" header="Valor Proposto" body={(rowData) => formatCurrency(rowData.pnht_valor_proposta)} />
            <Column field="pnht_acao" header="Ação" />
            <Column field="pnht_created_at" header="Data Ação" body={(rowData) => format(new Date(rowData.pnht_created_at), 'dd/MM/yyyy HH:mm:ss')} />
            {/* <Column field="baixa_categoria" header="Tipo" style={{width:'180px'}} body={(rowData)=>statusBodyTemplate(rowData)} /> */}
          </DataTable>
        </div>
      </div>

    </Dialog>
  )
}